'use client';

import { format } from 'date-fns';
import Link from 'next/link';
import type { Control } from 'react-hook-form';
import FormCheckbox from '../../../../components/form/FormCheckbox/FormCheckbox';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { WCHANCE_DRAW_STATUS, WChanceCollectionDetailEntryItem } from '../../types';
import { drawStatus } from '../../utils/drawStatus';
import styles from './WChanceCollectionEvents.module.scss';

export interface WChanceCollectionEventsProps {
  wChanceCollectionEvents: Array<WChanceCollectionDetailEntryItem>;
  WCHANCE_DRAW_STATUS: typeof WCHANCE_DRAW_STATUS;
  control: Control<{ excludeLost: string[] }>;
  onChangeCheck: () => void;
}

function WChanceCollectionEvents({
  wChanceCollectionEvents,
  WCHANCE_DRAW_STATUS,
  control,
  onChangeCheck,
}: WChanceCollectionEventsProps) {
  const isMultiPrize = (collection: WChanceCollectionDetailEntryItem) => {
    return collection.orderNum > 0;
  };

  return (
    <>
      <FormCheckbox
        name='excludeLost'
        items={[
          {
            value: 'excludeLost',
            child: <>当選・抽選待ちのみ</>,
          },
        ]}
        control={control}
        onChange={onChangeCheck}
      />
      <div className={utilsStyles.mtSmall}>
        {wChanceCollectionEvents.map((collection) => (
          <div
            className={`${styles.collectionItem} ${collection.entryId > 1 ? utilsStyles.mtXSmall : ''}`}
            key={`collection_events_${collection.entryId}`}
          >
            <div className={styles.prize}>
              {collection.status === WCHANCE_DRAW_STATUS.lost.key && <div className={styles.mask} />}
              <div style={statusStyle(drawStatus(collection.status)?.color)} className={styles.statusSquare}>
                <div
                  className={`${styles.statusInnerCircle} ${
                    collection.status === WCHANCE_DRAW_STATUS.won.key ? styles.largeText : styles.defaultText
                  }`}
                >
                  {statusText(collection.status, WCHANCE_DRAW_STATUS)}
                </div>
              </div>
              <div className={styles.detailArea}>
                <div className={styles.detailTop}>
                  {isMultiPrize(collection) && <div className={styles.orderText}>第{collection.orderNum}弾</div>}
                  <p className={styles.drawDate}>
                    抽選日時　
                    {format(new Date(collection.drawnAt), 'yyyy年MM月dd日 HH:mm')}
                  </p>
                </div>
                <p className={styles.prizeName}>{collection.prizeLabelName}</p>
              </div>
            </div>
            {collection.status === WCHANCE_DRAW_STATUS.won.key && (
              <div className={`${styles.linkButton}`}>
                <Link href={`/account/collection/${collection.prizeGoodsId}`} prefetch={false} className={styles.link}>
                  景品詳細へ
                </Link>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

function statusText(
  status: string,
  WCHANCE_DRAW_STATUS: {
    won: { key: string; text: string; color: string };
    pending: { key: string; text: string; color: string };
    submitted: { key: string; text: string; color: string };
    lost: { key: string; text: string; color: string };
  },
) {
  switch (status) {
    case WCHANCE_DRAW_STATUS.won.key:
      return <>当選</>;
    case WCHANCE_DRAW_STATUS.submitted.key:
      return (
        <>
          抽選
          <br />
          待ち
        </>
      );
    case WCHANCE_DRAW_STATUS.lost.key:
      return <>落選</>;

    default:
      return <></>;
  }
}

function statusStyle(color?: string): React.CSSProperties {
  if (!color) return {};
  return {
    color: `var(--color-${color})`,
    background: `var(--color-${color})`,
  };
}

export default WChanceCollectionEvents;
